import { CallsheetLocation } from '__types__';
import { v4 } from 'uuid';

export function duplicateCallsheetLocations(
  locations: CallsheetLocation[]
): CallsheetLocation[] {
  return locations.map(location => ({
    ...location,
    id: `temp-${v4()}`
  }));
}
